import { useEffect, useState } from "react";
import Accordion from "../../components/SetupComponents/PropertiesComponents/Accordion/Accordion";
import { IoCloseCircleOutline } from "react-icons/io5";
import MediaUpload from "../../components/SetupComponents/PropertiesComponents/MediaUpload";

const MoreInfo = ({
  propertyInfo,
  setPropertyInfo,
  handlePropertyInfoChange,
  handleArrayFieldChange,
  isEdit,
}) => {

  const accordionItems = [
    {
      title: "Dimension (in feet)",
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              North Dimension
            </label>
            <input
              type="text"
              name="northDimension"
              value={propertyInfo?.northDimension || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type in feet"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              East Dimension
            </label>
            <input
              type="text"
              name="eastDimension"
              value={propertyInfo?.eastDimension || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type in feet"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              South Dimension
            </label>
            <input
              type="text"
              name="southDimension"
              value={propertyInfo?.southDimension || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type in feet"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              West Dimension
            </label>
            <input
              type="text"
              name="westDimension"
              value={propertyInfo?.westDimension || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type in feet"
            />
          </div>
        </div>
      ),
    },
    {
      title: "More Info",
      content: (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Road Facing
            </label>
            <input
              type="text"
              name="roadFacing"
              value={propertyInfo?.roadFacing || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Village Name
            </label>
            <input
              type="text"
              name="villageName"
              value={propertyInfo?.villageName || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              SRO
            </label>
            <input
              type="text"
              name="sro"
              value={propertyInfo?.sro || ""}
              maxLength={20}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Survey No
            </label>
            <input
              type="text"
              name="surveyNo"
              value={propertyInfo?.surveyNo || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Market Rate per SQ.FT
            </label>
            <input
              type="number"
              name="marketRatePerSqft"
              value={propertyInfo?.marketRatePerSqft || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Per Cent/Ground Price
            </label>
            <input
              type="number"
              name="perCentGroundPrice"
              value={propertyInfo?.perCentGroundPrice || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Budget
            </label>
            <input
              type="text"
              name="budget"
              value={propertyInfo?.budget || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              LC
            </label>
            <input
              type="text"
              name="lc"
              value={propertyInfo?.lc || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Guideline
            </label>
            <input
              type="number"
              name="guideline"
              value={propertyInfo?.guideline || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Document Type
            </label>
            <input
              type="text"
              name="documentType"
              maxLength={20}
              value={propertyInfo?.documentType || ""}
              onChange={handlePropertyInfoChange}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              ROI
            </label>
            <input
              type="number"
              name="roi"
              value={propertyInfo?.roi || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Days
            </label>
            <input
              type="number"
              name="days"
              value={propertyInfo?.days || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,4}$/.test(value)) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Rate per SQ.FT
            </label>
            <input
              type="number"
              name="ratePerSqft"
              value={propertyInfo?.ratePerSqft || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Overall Minimum Budget
            </label>
            <input
              type="number"
              name="overallMinimumBudget"
              value={propertyInfo?.overallMinimumBudget || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Type"
            />
          </div>
          <div className="flex items-center">
            <label className="w-[50%] block text-sm font-medium text-gray-700">
              Overall Maximum Budget
            </label>
            <input
              type="number"
              name="overallMaxBudget"
              value={propertyInfo?.overallMaxBudget || ""}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 10) {
                  handlePropertyInfoChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
              className="w-[50%] px-3 py-2 input-focus rounded-md no-arrow"
              placeholder="Type"
            />
          </div>
          <div className="flex items-start">
            <label className="w-[50%] block text-sm font-medium text-gray-700 pt-2">
              Notes
            </label>
            <textarea
              name="notes"
              value={propertyInfo?.notes || ""}
              onChange={handlePropertyInfoChange}
              rows={3}
              className="w-[50%] px-3 py-2 input-focus rounded-md"
              placeholder="Type"
            />
          </div>
        </div>
      ),
    },
    {
      title: "Media Info",
      content: (
        <div className="space-y-8">
          <div className="grid grid-cols-1 gap-6">
            <MediaUpload
              mediaType="Images"
              files={propertyInfo?.imageAndVideos || []}
              onChange={(urls) => {
                handleArrayFieldChange("propertyBlueprints", urls);
                handleArrayFieldChange("imageAndVideos", urls);
              }}
              accept="image/*"       
              maxFiles={5}
              folderpath="property_rough_documents"
            />
          </div>
          <div className="space-y-4 w-full">
                  
              <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-gray-700">
                  Drive Link
                </label>
                <input
                  type="url"
                  name="driveLink"
                  value={propertyInfo?.driveLink || ""}
                  onChange={handlePropertyInfoChange}
                  className="px-3 py-2 w-full border rounded-md input-focus"
                  placeholder="Copy paste the Drive link"
                />
            
            </div>
          </div>
        
        </div>
      ),
    },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <Accordion items={accordionItems} />
    </div>
  );
};

export default MoreInfo;